import { render, staticRenderFns } from "./OpportunityResource.vue?vue&type=template&id=11742016"
import script from "./OpportunityResource.vue?vue&type=script&lang=js"
export * from "./OpportunityResource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports